import styled from 'styled-components'
import { motion } from 'framer-motion'

const Section = styled.section`
  padding: 96px 24px;
`

const Inner = styled.div`
  max-width: var(--max-width);
  margin: 0 auto;
`

const SectionLabel = styled.p`
  font-size: 0.85rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: var(--color-accent);
  margin-bottom: 12px;
  text-align: center;
`

const SectionTitle = styled.h2`
  font-size: clamp(1.8rem, 3vw, 2.5rem);
  font-weight: 700;
  letter-spacing: -0.02em;
  margin-bottom: 56px;
  text-align: center;
`

const StepsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`

const Step = styled(motion.div)`
  text-align: center;
  padding: 32px 20px;
  border-radius: 16px;
  background: var(--color-bg-card);
  border: 1px solid var(--color-border);
  transition: border-color 0.3s ease;

  &:hover {
    border-color: var(--color-accent);
  }
`

const StepNumber = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: var(--color-accent-glow);
  border: 1px solid var(--color-accent);
  color: var(--color-accent);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 1.1rem;
  margin: 0 auto 16px;
`

const StepTitle = styled.h3`
  font-size: 1.05rem;
  font-weight: 600;
  margin-bottom: 8px;
`

const StepDesc = styled.p`
  font-size: 0.9rem;
  color: var(--color-text-secondary);
  line-height: 1.6;
`

const STEPS = [
  { title: 'Discovery', desc: 'Free 30-minute call. We learn your business, surface blind spots, and identify where AI can make the biggest impact.' },
  { title: 'Assessment', desc: 'We map your workflows and recommend the right mix of AI agents, automation, and strategy.' },
  { title: 'Implementation', desc: 'We configure and deploy from our platform. No building from scratch; real results in days.' },
  { title: 'Optimization', desc: 'Ongoing refinement. We stay with you, improving and expanding as your business grows.' },
]

export default function ProcessSteps() {
  return (
    <Section>
      <Inner>
        <SectionLabel>How it works</SectionLabel>
        <SectionTitle>From discovery to results in days</SectionTitle>
        <StepsGrid>
          {STEPS.map((step, i) => (
            <Step
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.1 }}
            >
              <StepNumber>{i + 1}</StepNumber>
              <StepTitle>{step.title}</StepTitle>
              <StepDesc>{step.desc}</StepDesc>
            </Step>
          ))}
        </StepsGrid>
      </Inner>
    </Section>
  )
}
